export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20">
                  <i className="ri-eye-line text-lg text-primary-500"></i>
                </div>
                <span className="font-heading text-xl text-foreground-950">51暗网</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                聚合全网吃瓜、黑料、爆料内容的入口平台，帮助用户快速找到最新最热的娱乐八卦与事件追踪入口。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-foreground-800 text-sm mb-4">
                <a href="#cards" className="hover:text-primary-400 transition-colors">热门内容</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">话题热榜</a></li>
                <li><a href="#updates" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">最新动态</a></li>
                <li><a href="#carousel" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">焦点专题</a></li>
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">话题广场</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-foreground-800 text-sm mb-4">
                <a href="#index" className="hover:text-primary-400 transition-colors">快速入口</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="#app" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">APP下载</a></li>
                <li><a href="#faq" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">联系我们</a></li>
                <li><a href="#about" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">关于我们</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-foreground-800 text-sm mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-400">
                合作伙伴区域，具体站点名称与链接待更新。
              </p>
            </div>
          </div>

          <div className="border-t border-background-300/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 51暗网 · 吃瓜爆料聚合入口 · 本站仅提供内容聚合与入口导航服务
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">回到顶部</a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">帮助中心</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}